import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { Service } from '../entity/index';
import { DataService } from '../http/dataService';
import { K2ViewInteraction } from '../models/K2ViewInteraction.model';
import { Repository } from './repository';

@Service({
  api: 'addressBasedInteraction',
  model: K2ViewInteraction,
})
@Injectable({ providedIn: 'root' })
export class K2ViewInteractionService extends Repository<K2ViewInteraction> {
  constructor(dataService: DataService, @Inject(ENV) env: IEnvironment) {
    super({
      client: dataService,
      url: env.api.backend.k2view.endpoint as string,
    });
  }

  createFromDTO(item): K2ViewInteraction {
    return item;
  }
}
